/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PaymentIntentMode;

(function (PaymentIntentMode) {
  PaymentIntentMode["PAYMENT"] = "payment";
  PaymentIntentMode["SUBSCRIPTION"] = "subscription";
  PaymentIntentMode["SETUP"] = "setup";
})(PaymentIntentMode || (PaymentIntentMode = {}));